var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.00001C11.45 7.00001 10.9793 6.80434 10.588 6.41301C10.1967 6.02167 10.0007 5.55067 10 5.00001C9.99934 4.44934 10.1953 3.97867 10.588 3.58801C10.9807 3.19734 11.4513 3.00134 12 3.00001C12.5487 2.99867 13.0197 3.19467 13.413 3.58801C13.8063 3.98134 14.002 4.45201 14 5.00001C13.998 5.54801 13.8023 6.01901 13.413 6.41301C13.0237 6.80701 12.5527 7.00267 12 7.00001ZM10.5 21V9.00001H13.5V21H10.5Z",
    fill: "#673C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c4f725c719501dcf34e9ef9390754f40.svg";
export { ForwardRef as ReactComponent };